export const WebsiteName = "Fourier Machines"
export const fontWeightType = "fontWeightMedium"
export const fontWeightBold = "fontWeightBold"